
import { NigmaMessage } from "@/model/Message";
import { key, TOGGLE_CUSTOM_KEYBOARD } from "@/store";
import { nextTick } from "@vue/runtime-core";
import { Options, Vue } from "vue-class-component";
import { useStore } from "vuex";
import MessageWrapper from "./MessageWrapper.vue";
import Loading from "./Loading.vue";

@Options({
  components: {
    MessageWrapper,
    Loading,
  },
  watch: {
    async "$store.state.composerHeight"(newH) {
      this.setPaddingBottom(newH);
    },
    async "$store.state.messageHistory"(newM, oldM) {
      const newElements = newM.slice(-(newM.length - oldM.length));
      if (newM.length === 0) {
        this.messages = [];
      }
      for (const msg of newElements) {
        // console.log(msg);
        if (msg.delay) {
          this.writing = true;
          nextTick(() => {
            this.scrollOnBottom();
          });
          await awaitMillis(msg.delay / (this.fastMode ? 5 : 1));
          this.writing = false;
          this.messages.push(msg);
        } else {
          this.messages.push(msg);
        }
        if (msg.customKeyboard || msg.options) {
          this.$store.commit(TOGGLE_CUSTOM_KEYBOARD, true);
        } else {
          this.$store.commit(TOGGLE_CUSTOM_KEYBOARD, false);
        }
        nextTick(() => {
          this.scrollOnBottom();
        });
      }
    },
  },
  computed: {
    fastMode(): boolean {
      return this.$store.state.fastMode;
    },
  },
  data() {
    const messages: NigmaMessage[] = useStore(key).state.messageHistory;
    const writing = false;
    return { messages, writing };
  },
  methods: {
    scrollOnBottom: function () {
      const el = this.$el;
      el.children[el.childElementCount - 1].scrollIntoView({
        behavior: "smooth",
      });
    },
    setPaddingBottom: function (paddingBottom: number) {
      const el = this.$el;
      el.style.paddingBottom = paddingBottom + "px";
    },
  },
})
export default class ChatHistory extends Vue {}

function awaitMillis(millis: number): Promise<void> {
  return new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, millis);
  });
}
